import type { SettingsCategory, Subcategory } from "@/react/components/entityViews/settings/constants/settingsStructure";

export interface SubcategoryWithCategory {
  subcategory: Subcategory;
  category: SettingsCategory;
}

export function getAllSubcategories(categories: SettingsCategory[]): SubcategoryWithCategory[] {
  const result: SubcategoryWithCategory[] = [];
  categories.forEach((category) => {
    category.subcategories.forEach((subcategory) => {
      result.push({ subcategory, category });
    });
  });
  return result;
}

export function getSearchableText(subcategory: Subcategory, category: SettingsCategory): string {
  const searchableParts = [
    subcategory.label,
    subcategory.description,
    category.label,
    subcategory.settingScope,
    ...(subcategory.terms || []),
  ];
  return searchableParts.join(" ").toLowerCase();
}
